import compact from 'lodash/compact';

// TODO: update this to allow for non-US formats

export function oneLine(addressSource, { addressDelimiter, isLot } = { addressDelimiter: ', ', isLot: false }) {
  const { address, address2, lotNumber } = addressSource;
  const subAddress = isLot ? lotNumber : address2;
  const addressPart = subAddress ? compact([address, subAddress]).join(', ') : address;

  return compact([addressPart, zoneInfo(addressSource)]).join(`${addressDelimiter}`);
}

export function twoLine(addressSource, { includeBlank } = { includeBlank: true }) {
  const lines = [addressSource.address, zoneInfo(addressSource)];

  return includeBlank ? lines : compact(lines);
}

export function threeLine(addressSource, { includeBlank } = { includeBlank: true }) {
  const lines = [addressSource.address, addressSource.address2, zoneInfo(addressSource)];

  return includeBlank ? lines : compact(lines);
}

function zoneInfo(addressSource) {
  return compact([cityState(addressSource), addressSource.zip]).join(' ');
}

export function cityState(addressSource) {
  return compact([addressSource.city, addressSource.state]).join(', ');
}
